/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
//material
import Copy from 'material/copy/copy';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
import Title from 'material/copy/title/title';
// styles
import injectSheet from 'react-jss';
import styles from 'material/nodataview/nodataview_styles';



/* ========== ~~~~~~~~~~ CHART : NODATA: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class NoDataView extends Component {


    render() {
        return (
            <div className={`nodataview ${this.props.classes.nodataview}`}>
                <Copy>
                    <Title>Not Enough Data</Title>
                    <BodyCopy>
                        Unfortunately, you don’t have <br/>
                        enough data to display this element.
                    </BodyCopy>
                </Copy>
            </div>
        );
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(NoDataView);